import { render, staticRenderFns } from "./AppTopbar.vue?vue&type=template&id=2788a0f8&"
import script from "./AppTopbar.vue?vue&type=script&lang=js&"
export * from "./AppTopbar.vue?vue&type=script&lang=js&"
import style0 from "./AppTopbar.vue?vue&type=style&index=0&id=2788a0f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports